<div class="modal">
  <div class="mh">
    <div>
      <h2>这个账号已有处理中工单</h2>
      <p>请确认是否为同一个问题，避免重复提交。</p>
    </div>
    <button class="close" mat-dialog-close>×</button>
  </div>
  <div class="mb">
    <div
      class="dup"
      *ngFor="let item of data.workorders"
      (click)="checkFormDetail(item.id)"
    >
      <h3>{{ item.issue_name }}</h3>
      <p>{{ data.order.platform_name }} · {{ data.account }}</p>
      <div class="dup-grid">
        <div>
          <span>当前状态</span><span>{{ status(item.status) }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="mf">
    <button class="btn outline" (click)="close(true)">这是另一个问题</button>
    <!-- <button class="btn primary">查看原工单</button> -->
  </div>
</div>
